import { useSelector, useDispatch } from 'react-redux';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { LoadingModal } from './component/modal/modal';
import useWindowSize from './hook/useWindowSize';

function UrlCreate() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { mid: rawMid } = useParams();
    const { Rwidth, Rheight } = useWindowSize();

    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [maxFirstPage, setMaxFirstPage] = useState(40);
    const [listData, setListData] = useState([]);
    const [reload, setReload] = useState(false);

    useEffect(() => {
        dispatch(change_Current_Location('URL상품관리'));
        dispatch(changeHeaderTitle({ mainTitle: 'URL상품관리', subTitle: '' }));
    }, [dispatch]);

    // App(MidLayout)에서 이미 mid 유효성 검사를 끝냈으므로 여기선 그대로 사용
    const mid = rawMid ? decodeURIComponent(rawMid) : '';

    // 데이터 로딩
    useEffect(() => {
        if (!mid) return;
        (async () => {
            try {
                const { data } = await axios.get(
                    process.env.REACT_APP_API + `/shop/${mid}`,
                    { withCredentials: true }
                );
                console.log(data)
                if (data?.success) {
                    setListData(Array.isArray(data?.data?.products) ? data.data.products : []);
                    setTotalPage(Number(data?.data?.total_products || 0));
                } else {
                    setListData([]);
                }
            } catch (e) {
                console.error('[GET /shop/:mid] failed', e);
                setListData([]);
            } finally {
                setLoading(false);
            }
        })();
    }, [mid, page, reload]);

    return (
        <>
            {loading ? <LoadingModal /> : ''}
            <div style={{ background: '#fff', minHeight: '100dvh' }}>
                <MobileManagement mid={mid} products={listData} />
            </div>
        </>
    );
}

function MobileManagement({ mid, products }) {
    const navigate = useNavigate();

    const fmt = (n) => (Number.isFinite(n) ? n.toLocaleString('ko-KR') : n);
    const list =
        Array.isArray(products) && products.length > 0
            ? products
            : [
                {
                    id: 1,
                    title: '디어커스 오발레 욕실화 슬리퍼',
                    img: 'https://picsum.photos/seed/slipper1/600/600',
                    discountPct: 40,
                    price: 20900,
                    myPrice: 20900,
                    badges: ['오늘출발', '무료배송'],
                },
                {
                    id: 2,
                    title: '디어커스 오발레 욕실화 슬리퍼 2세트',
                    img: 'https://picsum.photos/seed/slipper2/600/600',
                    discountPct: 42,
                    price: 39800,
                    myPrice: 39800,
                    badges: ['오늘출발', '무료배송'],
                },
            ];

    return (
        <div className="mobile-management-wrap">
            <h2 className="mobile-management-heading">{mid} 가맹점 상품목록</h2>

            <div className="mobile-management-grid">
                {list.map((p) => (
                    <article
                        className="mobile-management-card"
                        key={p.id}
                        onClick={() => navigate(`/${mid}/detail`, { state: p })}
                    >
                        <div className="mobile-management-thumb">
                            <img src={p.img} alt={p.title} />
                        </div>

                        <h3 className="mobile-management-title">{p.title}</h3>

                        <div className="mobile-management-price-row">
                            {'discountPct' in p && (
                                <span className="mobile-management-discount">{p.discountPct}%</span>
                            )}
                            {'price' in p && (
                                <span className="mobile-management-price">{fmt(p.price)}원</span>
                            )}
                        </div>

                        <div className="mobile-management-myprice">
                            나의 할인가 <strong>{fmt(p.myPrice ?? p.price)}원</strong>
                        </div>

                        {Array.isArray(p.badges) && p.badges.length > 0 && (
                            <div className="mobile-management-badges">
                                {p.badges.map((b, i) => (
                                    <span className="mobile-management-badge" key={i}>
                                        {b}
                                    </span>
                                ))}
                            </div>
                        )}
                    </article>
                ))}
            </div>
        </div>
    );
}

export default UrlCreate;
